var lib_core = require("lib-core");

var FabData = function(settings){
    var self = this;

    this.makeObservableTreeNode();

    this.OTW = this.value("OTW", true);
    this.OTT = this.value("OTT", true);
    this.OTP = this.value("OTP", true);
    this.OPP = this.value("OPP", true);
    this.OAR = this.value("OAR", true);
    this.min_copper_to_boarder = this.value("min_copper_to_boarder", true);
    this.pthMinEndsize = this.value("pthMinEndsize", true);
    this.npthMinEndsize = this.value("npthMinEndsize", true);
    this.minMilSize = this.value("minMilSize", true);
    this.viaMinEndsize = this.value("viaMinEndsize", true);
    this.silkscreenMinWidth = this.value("silkscreenMinWidth", true);

    if(settings !== undefined) this.load(settings);
};
lib_core.mixin(FabData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(FabData, "FabData");

module.exports = FabData;

FabData.prototype.load = function(settings) {
    if(settings.OTW !== undefined) this.OTW(settings.OTW);
    if(settings.OTT !== undefined) this.OTT(settings.OTT);
    if(settings.OTP !== undefined) this.OTP(settings.OTP);
    if(settings.OPP !== undefined) this.OPP(settings.OPP);
    if(settings.OAR !== undefined) this.OAR(settings.OAR);
    if(settings.min_copper_to_boarder !== undefined) this.min_copper_to_boarder(settings.min_copper_to_boarder);
    if(settings.pthMinEndsize !== undefined) this.pthMinEndsize(settings.pthMinEndsize);
    if(settings.npthMinEndsize !== undefined) this.npthMinEndsize(settings.npthMinEndsize);
    if(settings.minMilSize !== undefined) this.minMilSize(settings.minMilSize);
    if(settings.viaMinEndsize !== undefined) this.viaMinEndsize(settings.viaMinEndsize);
    if(settings.silkscreenMinWidth !== undefined) this.silkscreenMinWidth(settings.silkscreenMinWidth);
};

FabData.prototype.toolsize = function(endsize, plated) {
    //All drill diameters are increments of 0.05mm
    var rounded_endsize = Math.round(endsize/50)*50;

    if (plated) {
        if (rounded_endsize <= 450) { // Considered via
            return rounded_endsize + 100;
        } else {
            return rounded_endsize + 150;
        }
    } else {
        return rounded_endsize + 50;
    }
};

FabData.prototype.viaPadDiameter = function(hole_endsize) {
    var toolsize = this.toolsize(hole_endsize, true);
    return toolsize+2*this.OAR();
};

FabData.prototype.calculateBoardPrice = function(width, height, nrOfLayers, nrOfBoards)
{
    var euroToDollar = 1 / 0.75;
    var DM2ToInch2 = 1 / 0.064516;

    var magicFactor = 1.15;
    var setupCost = 5 * euroToDollar;
    var pricePerSquareInch = 5;

    if (nrOfLayers != 2 && nrOfLayers != 4) {
        return -1;
    }

    var pcbAreaInSquareInch = DM2ToInch2 * (width * height) / 10000000000.0;

    var price = setupCost + (Math.ceil(nrOfBoards/3.0) * ((nrOfLayers/2) * pricePerSquareInch) * pcbAreaInSquareInch) * magicFactor;
    price = Math.round(price*100) / 100; // round price to 2 digits

    return price;
};
